<div class="row no-gutters">
  <div class="col-12 table-responsive">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <th scope="col" width="20%"></th>
          <th scope="col" width="20%">VIN</th>
          <th scope="col" width="15%">Make</th>
          <th scope="col" width="15%">Model</th>
          <th scope="col" width="15%">Year</th>
          <th scope="col" width="15%">Status</th>
        </tr>
      </thead>
      <tbody *ngIf="vehicleList && vehicleList.length > 0; else noVehicles" class="scroll-height-screenHeight hide-x-scroll">
        <tr *ngFor="let vehicle of vehicleList" class="pointer">
          <td width="20%" *ngIf="vehicle.logo" class="pr-0 text-center">
            <img class="vehicle-image-sm" src="{{vehicle.logo}}" alt="{{vehicle.model}}" />
          </td>
          <td width="20%" *ngIf="!vehicle.logo" class="pr-0 text-center">
            <img class="vehicle-image-sm" src="assets/images/car-placeholder.png"
              alt="{{vehicle.model}}" />
          </td>
          <td width="20%" scope="row">{{vehicle.vin}}</td>
          <td width="15%" scope="row">{{vehicle.make}}</td>
          <td width="15%"> {{vehicle.model}}</td>
          <td width="15%"> {{vehicle.year}}</td>
          <td width="15%">
            <i *ngIf="vehicle.status=='ACTIVE' || vehicle.status=='ENROLLED'"
              class="fa fa-check-circle text-success" aria-hidden="true"></i>
            <i *ngIf="vehicle.status=='INACTIVE'" class="fa fa-exclamation-circle text-danger"
              aria-hidden="true"></i>
            <i *ngIf="vehicle.status=='PENDING' || vehicle.status=='ASSIGNED' || vehicle.status=='PROVISIONED'"
              class="fa fa-minus-circle text-warning" aria-hidden="true"></i>

            {{vehicle.status | customText}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ng-template #noVehicles>
  <div class="row no-gutters">
    <div class="col-12 mt-5 text-center">
      <h3 class="text-muted">No vehicles available.</h3>
    </div>
  </div>
</ng-template>